import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The body of a cabinet "back to the list" link: a small panel-plated icon box followed by the
 * label, one look in every host. The label shows from md up (the control's own aria-label carries it below that).
 *
 * The host is `display: contents`, so both spans stay DIRECT children of the consuming anchor or button —
 * its own flex gap and alignment keep working untouched. Hovering that enclosing control slides the icon box
 * left and inks the label; the brick keys the hover off it, so a host passes no hover class. The chevron
 * arrives by projection (each app ships its own icon component).
 */
@Component({
  selector: 'hlm-app-shell-back-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
  template: `
    <span
      class="grid size-5 place-items-center rounded-md bg-panel text-c2 transition-transform duration-[var(--t-mid)]
        ease-[var(--ease-smooth)] motion-reduce:transition-none [:is(a,button):hover_&]:-translate-x-0.5"
    >
      <ng-content />
    </span>
    <span
      class="hidden whitespace-nowrap text-sm font-semibold text-c2 transition-colors duration-[var(--t-fast)]
        ease-[var(--ease-smooth)] md:inline [:is(a,button):hover_&]:text-ink"
      >{{ label() }}</span
    >
  `,
})
export class HlmAppShellBackLink {
  readonly label = input.required<string>();
}
